import { render, staticRenderFns } from "./TranslateRecipe.vue?vue&type=template&id=e26216a4&scoped=true"
import script from "./TranslateRecipe.vue?vue&type=script&lang=js"
export * from "./TranslateRecipe.vue?vue&type=script&lang=js"
import style0 from "./TranslateRecipe.vue?vue&type=style&index=0&id=e26216a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26216a4",
  null
  
)

export default component.exports